import React, { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Mail, MailX } from "lucide-react";
import { toast } from "sonner";
import { useConfirm } from "@/context/ConfirmContext";

export default function EmailPreferences() {
  const { user, setUser } = useAuth();
  const confirm = useConfirm();
  const [busy, setBusy] = useState(false);
  if (!user || user.role !== "student") return null;
  const off = !!user.consent?.withdrawn_at;

  const toggle = async () => {
    if (!off && !(await confirm({
      title: "Stop programme emails?",
      description: "You'll no longer receive team announcements, session details, survey reminders or attendance follow-ups by email. Admins will see this on the roster and may contact you another way. You can turn emails back on here any time.",
      confirmText: "Stop emails", destructive: true,
    }))) return;
    setBusy(true);
    try {
      await api.post(off ? "/consent/accept" : "/consent/withdraw");
      setUser({ ...user, consent: { ...(user.consent || {}), given_at: user.consent?.given_at || new Date().toISOString(), withdrawn_at: off ? null : new Date().toISOString() } });
      toast.success(off ? "Programme emails turned back on" : "Programme emails stopped");
    } catch { toast.error("Could not update"); }
    finally { setBusy(false); }
  };

  return (
    <div className="border border-[#E5E7EB] bg-white p-4 flex items-center gap-4 flex-wrap" data-testid="email-preferences">
      {off ? <MailX size={18} className="text-[#A23232]" /> : <Mail size={18} className="text-[#25AAAA]" />}
      <div className="flex-1 min-w-[200px]">
        <div className="text-sm font-semibold">Programme emails: {off ? "off" : "on"}</div>
        <div className="text-xs text-[#525252]">{off ? "You've asked us not to email you about iTeams." : "We only email you about iTeams, until the programme ends."} <a href="/privacy" className="underline">Privacy notice</a></div>
      </div>
      <button onClick={toggle} disabled={busy} className="text-xs font-semibold underline text-[#0F1F2E] hover:text-[#25AAAA]" data-testid="email-preferences-toggle">
        {off ? "Turn emails back on" : "Stop programme emails"}
      </button>
    </div>
  );
}
